export function courtesyCode(raw: string): string {
  const code = raw.trim().replace(/^mowe:\/\/cortesia\//i, '');
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(code)) throw new Error('El QR no corresponde a una invitación de cortesía.');
  return code;
}
export function chileToday(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}
export function freeInvitations(total: number, reserved: number): number { return Math.max(0, total - reserved); }
export function monthEnd(date: string): string {
  const [year, month] = date.split('-').map(Number);
  return new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10);
}
